import React from 'react';
import Statuses from '../../../model/Statuses';
import useEnumerableModel from '../../data/hooks/useEnumerableModel';
import useTranslation from './Translations/useTranslation';
const Status = ({ value = null }) => {
    const { t } = useTranslation();
    const { optionsByValue } = useEnumerableModel(Statuses);
    const status = value ? optionsByValue[value] : null;
    return <span>{(status && status.name) || t('N/A')}</span>;
};
export default Status;
